import { render, staticRenderFns } from "./WeChat_service.vue?vue&type=template&id=26a74767&scoped=true&"
import script from "./WeChat_service.vue?vue&type=script&lang=js&"
export * from "./WeChat_service.vue?vue&type=script&lang=js&"
import style0 from "./WeChat_service.vue?vue&type=style&index=0&id=26a74767&prod&lang=less&"
import style1 from "./WeChat_service.vue?vue&type=style&index=1&id=26a74767&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a74767",
  null
  
)

export default component.exports